import React, { useMemo, useState } from "react";
import { FileDownload, ListAlt } from "@mui/icons-material";

import { useCustomWorkflow } from "fond/hooks/useCustomWorkflow";
import BomModal from "fond/project/bom/BomModal";
import { Architecture, Project, WORKFLOW_KEYS } from "fond/types";
import { AccordionStepper, AccordionStepperPane, StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

import ServiceAreaPanel from "./ServiceAreaPanel";

interface ArtefactsPanelProps {
  project: Project;
  versionId: string;
  architecture: Architecture | null;
  readOnly: boolean;
}

const ArtefactsPanel: React.FC<ArtefactsPanelProps> = ({ project, versionId, architecture, readOnly }: ArtefactsPanelProps) => {
  const { workflowState } = useCustomWorkflow({ versionId, key: WORKFLOW_KEYS.PLANNER_EXTENDED.SERVICE_AREA });
  const { open } = useStackedNavigationContext();
  const [isBomModalOpen, setIsBomModalOpen] = useState(false);

  const accordionPanes: AccordionStepperPane[] = useMemo(
    () => [
      {
        header: "Service Area",
        id: "service-area",
        content: <ServiceAreaPanel project={project} versionId={versionId} readOnly={readOnly} />,
        isComplete: workflowState === "COMPLETE",
      },
    ],
    [project, readOnly, versionId, workflowState]
  );

  return (
    <>
      <AccordionStepper id={`${project.ID}-artefacts`} panes={accordionPanes} autoMove={[""]} variant="outlined" />
      <StackedNavigationButton
        data-testid="view-bill-of-materials-button"
        icon={<ListAlt />}
        title="Bill of materials"
        subtitle="View design bill of materials"
        sx={{ m: 0, mt: 1 }}
        onClick={() => setIsBomModalOpen(true)}
      />
      <StackedNavigationButton
        data-testid="export-construction-prints-button"
        icon={<FileDownload />}
        title="Construction prints"
        subtitle="Export construction prints"
        sx={{ m: 0, mt: 1 }}
        onClick={() => open("construction-prints-export")}
      />
      {isBomModalOpen && <BomModal project={project} architecture={architecture} onClose={() => setIsBomModalOpen(false)} />}
    </>
  );
};

export default ArtefactsPanel;
